module.exports = __webpack_public_path__ + "static/icons/icon-user-report-60f5dd4f86c325333e5739fe25228e01.svg";